import React, { useEffect, useRef, useState } from 'react';
import { useEscapeKey } from '../hooks/useEscapeKey';

// Typed confirmation — the user must enter the exact project name before the
// destructive button enables. Mirrors the iOS delete flow.
const DeleteProjectModal = ({ project, onConfirm, onClose }) => {
    const [value, setValue] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const inputRef = useRef(null);
    const name = (project?.name || 'Untitled').trim();

    useEffect(() => { inputRef.current?.focus(); }, []);
    useEscapeKey(onClose);

    const confirmed = value.trim() === name;

    const submit = async (e) => {
        e.preventDefault();
        if (!confirmed || busy) return;
        setBusy(true);
        setError('');
        try {
            await onConfirm();
        } catch (err) {
            setError(err?.message || 'Could not delete project.');
            setBusy(false);
        }
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <form
                className="modal-card new-project-card"
                onClick={(e) => e.stopPropagation()}
                onSubmit={submit}
            >
                <div className="new-project-eyebrow delete-project-eyebrow">DELETE PROJECT</div>
                <div className="new-project-title">Delete “{name}”?</div>
                <div className="delete-project-warning">
                    This permanently deletes every track, lyric, idea, and art file in
                    this project — for all members. This cannot be undone.
                </div>
                <div className="delete-project-prompt">
                    Type <strong>{name}</strong> to confirm.
                </div>
                <input
                    ref={inputRef}
                    className="new-project-input"
                    type="text"
                    placeholder="Project name"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    disabled={busy}
                />
                {error && <div className="new-project-error">{error}</div>}
                <div className="new-project-actions">
                    <button type="button" className="btn-ghost" onClick={onClose} disabled={busy}>
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn-primary btn-danger"
                        disabled={!confirmed || busy}
                    >
                        {busy ? 'Deleting…' : 'Delete forever'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default DeleteProjectModal;
